import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import {
  Card,
  CardMedia,
  CardContent,
  Button,
  Typography,
  CircularProgress,
  Snackbar,
  SnackbarContent,
} from '@material-ui/core'
import Cookies from 'js-cookie'
import { useHistory } from 'react-router-dom'
import {RiImageAddFill} from 'react-icons/ri'
import {IoPersonSharp} from 'react-icons/io5'
import UploadForm from './UploadForm'
import '../../assets/styles.css'

const base_url = 'https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm'

export default function AddSalesPerson(props) {
  const token = Cookies.get("token")
  const history = useHistory()
  const [salesImg, setSalesImg] = useState(null)
  const [img, setImg] = useState(null)
  const [imgPath, setImgPath] = useState(null)
  const [uuid, setUUID] = useState(null)
  const [imgLoad, setImgLoad] = useState(false)
  const [validationsPassed, setValidationsPassed] = useState(false)
  const [locationsList, setLocationsList] = useState(null)
  const [snackbar, setSnackbar] = useState(null)

  const getLocations = () => {
    const request = fetch(`${base_url}/salesperson/locations`, {
      headers: {
        token: token
      }
    })

    request.then(response => response.json())
    .then(data => setLocationsList(data))
    .catch(error => console.log(error))
  }

  useEffect(() => getLocations(), [])

  const handleSnackbarClose = () => {
    setSnackbar(null)
  }

  const getUUID = (img) => {
    if(img) {
      const fd = new FormData()
      fd.append('imgPath', img, img.name)

      const request = fetch(`${base_url}/salesperson/uploadImage`, {
        method: "POST",
        headers: {
          // 'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': "*",
          'token': token
        },
        body: fd
      })

      request.then(response => {
        if(response.ok === true) return response.json()
      })
      .then(data => {
        if(data) {
          setUUID(data.uuid)
          setImgLoad(false)
        }
      })
      .catch(error => console.log(error))
    } else {
      setSnackbar('A photo of the sale consultant is required.')
    }
  }

  const handlePhotoSelect = (e) => {
    const {files} = e.target
    const path = URL.createObjectURL(files[0])

    setImg(files[0])
    setImgPath(path)
    setImgLoad(true)

    getUUID(files[0])
  }

  const handleSubmit = (salesPersonObj) => {
    const { first, last, locationID, Inclusion} = salesPersonObj
    const pending = {
      'locationID': locationID,
      'imgPath': imgPath,
      'lastName': last,
      'firstName': first,
      'uuid': uuid,
      'inclusionStatus': Inclusion,
    }


    const request = fetch(`${base_url}/salesperson/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      },
      body: JSON.stringify(pending)
    })

    request.then(response => {
      if(response.ok === true) {
        setSnackbar(`${first} ${last} has been successfully added`)
        // setTimeout(() => history.push('/sales-consultants'), 2500)
        window.location.reload()
      }
    })
    .catch(error => {
      console.log(error)
      setSnackbar('Oops! Something went wrong. Please make sure all required fields are filled out correctly')
    })
  }

  if(!locationsList) return <CircularProgress />

  return (
    <div className="sales-edit">

      <Snackbar
        open={Boolean(snackbar)}
        autoHideDuration={4500}
        onClose={handleSnackbarClose}
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      >
        <SnackbarContent
          message={snackbar}
        />
      </Snackbar>

      <Card className="card">
        <CardMedia className="media">
          {imgPath ?
            <img
              className="sales-img"
              src={imgPath}
              alt=""
              style={{height: '325px', width: '274px', marginTop: '40px'}}
            />
          :
            <IoPersonSharp className="avatar-sales" />
          }
          <form encType='multipart/form-data'>
            <input
              id="contained-button-file"
              name="imgPath"
              accept="image/*"
              type="file"
              onChange={handlePhotoSelect}
              style={{display: 'none'}}
            />
          </form>
          <label htmlFor="contained-button-file">
            <Button
              variant="outlined"
              component="span"
              className="upload-btn"
            >
              <Typography style={{fontSize: '12px'}}>ADD PHOTO</Typography>
              <RiImageAddFill style={{marginLeft: '5px', fontSize: '11px'}}/>
            </Button>
          </label>
        </CardMedia>
        <CardContent style={{width: "100%", marginTop: 43}}>
          <UploadForm
            submit={handleSubmit}
            validationsPassed={validationsPassed}
            inclusion={1}
            locationsList={locationsList}
          />
        </CardContent>
      </Card>
    </div>
  )
}
